module.exports = __webpack_public_path__ + "static/img/userheader.5d29cb0f.png";